<script>

import { fancyAlert, fancyConfirm } from "./notification.js";
import { status } from "./status.js";
import page from "page";
import { requestPasswordChange, requestTokenReset } from "./apihandler.js";
import { tl } from "./multilang.js";

let currentPassword, newPassword1, newPassword2;

async function changePassword() {

    let id = $status.subscription.id;
    let code = $status.subscription.sessionAuth;
    
    requestPasswordChange(id, code, currentPassword, newPassword1)
    .then(async () => {
        await fancyAlert(tl("Password changed"));
        page("/services");
    })
    .catch(async (error) => {
        if (error == 403) {
            await fancyAlert(tl("Wrong password or expired session, try again or log back in"), tl("Error"));
        }
        else if (error == 490) {
            await fancyAlert(tl("Please open you administrative token in the ZofToken app and retry when ready"), tl("Open your token"), tl("OK"));;
        }
        else {
            await fancyAlert(error), tl("Error");
        }
    });
}

async function resetToken() {

    if (await fancyConfirm(tl("Are you sure? You will receive an email with your new enrollment data."))) {

        let id = $status.subscription.id;
        let code = $status.subscription.sessionAuth;

        requestTokenReset(id, code, currentPassword)
        .then(async () => {
            await fancyAlert(tl("Your administrative ZofToken has been reset, you'll need to enroll it before you can log back in"));
            page("/");
            $status.loggedIn = false;
            $status.subscription = {};
        })
        .catch(async (error) => {
            if (error == 403) {
                await fancyAlert(tl("Wrong password or expired session, try again or log back in", tl("Error")));
            }
            else {
                await fancyAlert(error, tl("Error"));
            }
        });
    }
}


</script>

<section class=" has-background-grey-lightest	">
  <div class="container">

<div class="columns is-centered content">
    <div class="column is-two-thirds">
        <div class="box">
            <h4>{tl("My credentials")}</h4>
            <div class="columns">
                <div class="column gap gap-right is-half">
                    <label class="label">{tl("Current password")}</label>
                    <div class="zt-field-wrapper">
                        <div class="control">
                            <input class="input" type="password" bind:value={currentPassword}>
                        </div>
                        <p class="help">{tl("You need to enter your password to do anything else in this page.")}</p>
                    </div>
                </div>
                <div class="column">
                    <label class="label">{tl("Reset your administrative ZofToken")}</label>
                    <div class="zt-field-wrapper">
                        <button class="button is-danger" disabled={!currentPassword} on:click={resetToken}>{tl("Reset your administrative ZofToken")}</button>
                    </div>

                    <hr />
                    
                    <label class="label">{tl("Change your password")}</label>
                    <div class="zt-field-wrapper">
                        <label class="zt-label">{tl("New password")}</label>
                        <div class="control">
                            <input class="input" type="password" bind:value={newPassword1}>
                        </div>
                    </div>
                    <div class="zt-field-wrapper">
                        <label class="zt-label">{tl("Repeat the new password")}</label>
                        <div class="control">
                            <input class="input" type="password" bind:value={newPassword2}>
                            <p class="help has-text-danger" class:is-invisible={!(newPassword1 && (newPassword1 != newPassword2))}>{tl("Passwords do not match")}</p>
                        </div>
                    </div>
                    <button class="button is-link" disabled={!(currentPassword && newPassword1 && (newPassword1 == newPassword2))} on:click={changePassword}>{tl("Submit")}</button>
                    <button class="button is-link is-light" on:click={() => page("/services")}>{tl("Cancel")}</button>
                </div>
            </div>
            
        </div>
    </div>
</div>

  </div>
</section>